import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useProfile } from "../Hooks/UserHooks";
import { userRolesSidebarData } from "../Layout/VerticalLayout/SidebarData"; // Import sidebar data function

const AuthProtected = (props) => {
  const { userProfile, loading } = useProfile();
  const location = useLocation();

  // Check if authUser is present in localStorage
  const authUser = JSON.parse(localStorage.getItem('authUser'));
  const isLocked = JSON.parse(localStorage.getItem('isLocked'))
  
  useEffect(() => {
  if (!authUser) return;

  // 🔹 DEMO USER EXPIRY HANDLING (Exact timing)
  if (authUser.response?.isDemo && authUser.response?.expiresAt) {
    const expiry = new Date(authUser.response.expiresAt).getTime();
    const now = new Date().getTime();
    const timeLeft = expiry - now;

    const totalSeconds = Math.floor(timeLeft / 1000);
    const totalMinutes = Math.floor(totalSeconds / 60);
    const totalHours = Math.floor(totalMinutes / 60);
    const totalDays = Math.floor(totalHours / 24);

    const days = totalDays;
    const hours = totalHours % 24;
    const minutes = totalMinutes % 60;
    const seconds = totalSeconds % 60;

    console.log(
      `Demo User expiry in: ${days}d ${hours}h ${minutes}m ${seconds}s`
    );

    if (timeLeft > 0) {
      const demoTimeout = setTimeout(() => {
        localStorage.removeItem("authUser");
        console.log("Demo User Expired - Logged Out Automatically");
        window.location.href = "/login";
      }, timeLeft);

      return () => clearTimeout(demoTimeout);
    } else {
      localStorage.removeItem("authUser");
      console.log("Demo User Expired - Logged Out Immediately");
      window.location.href = "/login";
      return;
    }
  }

  // 🔹 JWT TOKEN EXPIRY HANDLING
  const token = authUser.token;

  try {
    const { exp } = JSON.parse(atob(token.split(".")[1]));
    const currentTimeInSeconds = Math.floor(new Date().getTime() / 1000);
    const timeUntilExpiryInSeconds = exp - currentTimeInSeconds;
    const timeUntilExpiryInMs = timeUntilExpiryInSeconds * 1000;

    if (timeUntilExpiryInSeconds > 0) {
      const days = Math.floor(timeUntilExpiryInSeconds / (24 * 60 * 60));
      const hours = Math.floor(
        (timeUntilExpiryInSeconds % (24 * 60 * 60)) / (60 * 60)
      );
      const minutes = Math.floor(
        (timeUntilExpiryInSeconds % (60 * 60)) / 60
      );
      const seconds = timeUntilExpiryInSeconds % 60;

      // console.log(
      //   `Token Expiry In: ${days}d ${hours}h ${minutes}m ${seconds}s`
      // );

      const logoutTimeout = setTimeout(() => {
        localStorage.removeItem("authUser");
        console.log("Token Expired - User Logged Out Automatically");
        window.location.href = "/login";
      }, timeUntilExpiryInMs);

      return () => clearTimeout(logoutTimeout);
    } else {
      localStorage.removeItem("authUser");
      console.log("Token Expired - User Logged Out Immediately");
      window.location.href = "/login";
    }
  } catch (error) {
    console.error("Invalid Token:", error);
    localStorage.removeItem("authUser");
    window.location.href = "/login";
  }
}, [authUser]);

  if (loading) {
    return  <Navigate to={{ pathname: "/login", state: { from: location } }} />;
  }

  // Redirect to lockscreen if isloacked is true
  if(isLocked){
    return  <Navigate to={{ pathname: "/auth-lock-screen", state: { from: location } }} />;
  }

  // Redirect to login if authUser is not found
  if (!authUser) {
    return <Navigate to={{ pathname: "/login", state: { from: location } }} />;
  }

  // Check if userProfile is present
  if (!userProfile) {
    return <Navigate to={{ pathname: "/login", state: { from: location } }} />;
  }

  const allowedRoutes = getAllowedRoutes(userProfile.role);

  const currentPath = location.pathname;

  const isAllowed = allowedRoutes.some((route) =>
    currentPath.startsWith(route)
  );

  if (!isAllowed) {
    return <Navigate to="/dashboard" />;
  }

  return <>{props.children}</>;
};

const getAllowedRoutes = (role) => {
  const sidebarData = userRolesSidebarData(role);

  const flattenRoutes = (data) => {
    return data.reduce((acc, item) => {
      if (item.url) acc.push(item.url);

      if (item.subItem) {
        item.subItem.forEach((sub) => acc.push(sub.link));
      }

      return acc;
    }, []);
  };

  const routes = flattenRoutes(sidebarData);

  // ✅ allow dynamic project details route
  routes.push("/project-details");
  routes.push("/lead-details");
  routes.push("/user-leads-page");

  return routes;
};

export default AuthProtected;

//master ->  sidebar data || user routes defined { limited routes  -> output  }
// master -> restrictions || routes defined === accessed route -> /dashboard 